<template>
  <div class="card">
    <vs-row>
    <vs-col lg="3">
      <vs-row style="padding: 0 5% 0 0">
        <vs-col class="mb-2">
          <vs-button
            square
            danger
            @click="changePestana()"
            style="width: 95%;"
          >
          Redactar
        </vs-button>
        </vs-col>
        <vs-col :style="activeEnviados == true ? 'height: 40px' : 'line-height: 40px'">
          <button type="button" class="botonEstilos" @click="getOpcion('enviados')">
            <vs-row  style="display: flex; justify-content: center; align-items: center;">
              <vs-col lg="1"><div v-if="activeEnviados == true" class="trapezium"></div></vs-col>
              <vs-col lg="9" :class="activeEnviados == true ? 'cBlue' : 'cGray'">
                <i class="fas fa-paper-plane anchoIcono mr-2 pl-2"></i><span class="anchoLetra"> Enviados</span>
              </vs-col>
              <vs-col lg="2" class="text-center" :class="activeEnviados == true ? 'cBlue' : 'cGray'"> <span v-if="emails.pagination && tipoCorreo == true" class="anchoLetra">{{emails.pagination.count}}</span></vs-col>
            </vs-row>
          </button>
        </vs-col>
        <vs-col :style="activeGuardados == true ? 'height: 40px' : 'line-height: 40px'">
          <button type="button" class="botonEstilos" @click="getOpcion('guardados')">
            <vs-row style="display: flex; justify-content: center; align-items: center;">
              <vs-col lg="1"><div v-if="activeGuardados == true" class="trapezium"></div></vs-col>
              <vs-col lg="9"  :class="activeGuardados == true ? 'cBlue' : 'cGray'">
                <i class="fas fa-trash anchoIcono mr-2 pl-2"></i><span class="anchoLetra"> Guardados</span>
              </vs-col>
              <vs-col lg="2" class="text-center" :class="activeGuardados == true ? 'cBlue' : 'cGray'"> <span v-if="emails.pagination && tipoCorreo == false" class="anchoLetra">{{emails.pagination.count}}</span></vs-col>
            </vs-row>
          </button>
        </vs-col>
        <!-- <vs-col :style="activeSalida == true ? 'height: 40px' : 'line-height: 40px'">
          <button type="button" class="botonEstilos" @click="getOpcion('salida')">
            <vs-row style="display: flex; justify-content: center; align-items: center;">
              <vs-col lg="1"><div v-if="activeSalida == true" class="trapezium"></div></vs-col>
              <vs-col lg="9"  :class="activeSalida == true ? 'cBlue' : 'cGray'">
                <i class="fas fa-sign-out-alt anchoIcono mr-2 pl-2"></i><span class="anchoLetra"> Bandeja de salida</span>
              </vs-col>
              <vs-col lg="2" class="text-center" :class="activeSalida == true ? 'cBlue' : 'cGray'"> <span class="anchoLetra">{{totalProceso}}</span></vs-col>
            </vs-row>
          </button>
        </vs-col> -->
      </vs-row>
    </vs-col>
    <vs-col lg="9">
      <vs-row class="mb-4">
        <vs-col sm="12" lg="4">
            <form autocomplete="off">
                <label for="institucion" class="labelInput">
                    Institución
                </label>
                <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('institucion')">
                        Requerido
                    </template>
                    <template v-if="instituciones.length" autocomplete="off">
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </template>
                    <template v-else>
                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                        </vs-option>
                    </template>
                </vs-select>
            </form>
        </vs-col>
        <vs-col sm="12" lg="4">
            <form autocomplete="off">
                <label for="cicloEscolar" class="labelInput">
                    Ciclo Escolar
                </label>
                <vs-select filter class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                        Requerido
                    </template>
                    <template v-if="ciclosEscolares.length" autocomplete="off">
                        <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </template>
                    <template v-else>
                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                        </vs-option>
                    </template>
                </vs-select>
            </form>
        </vs-col>
        <vs-col w="4">
          <label for="cicloEscolar" class="labelInput">
              Origen
          </label>
          <vs-select placeholder="Origen" class="pt-0" v-model="origen">
            <vs-option label="Módulo de mailing" value="usuario">
                Módulo de mailing
            </vs-option>
            <vs-option label="Automatizado" value="sistema">
              Automatizado
            </vs-option>
            <vs-option label="Carta de invitación de pago" value="invitación">
              Carta de invitación de pago
            </vs-option>
            <vs-option label="Carta de suspensión" value="suspencion">
              Carta de suspensión
            </vs-option>
            <vs-option label="Error de facturación" value="error_facturacion">
              Error de facturación
            </vs-option>
          </vs-select>
          <!-- <div v-if="origen !== ''" @click="origen = ''" class="tache">
              <i class="far fa-times-circle"></i>
          </div> -->
        </vs-col>
        <vs-col w="12">
          <div class="d-flex justify-content-end">
            <vs-button
              success
              @click="activeFiltros =! activeFiltros"
            >
              <i class="fas fa-filter mr-2"></i> FILTRAR CORREOS
            </vs-button>
            <vs-button
              @click="getInformacion()"
            >
              BUSCAR
            </vs-button>
          </div>
        </vs-col>
        <vs-col w="12" v-if="activeFiltros" class="mt-3">
          <vs-row>
            <vs-col w="4">
              <vs-input
                type="date"
                v-model="fecha_ini"
                label="Fecha de inicio"
              />
              <div v-if="fecha_ini !== ''" @click="fecha_ini = '', fecha_fin = ''" class="tache">
                  <i class="far fa-times-circle"></i>
              </div>
            </vs-col>
            <vs-col w="4">
              <vs-input
                type="date"
                v-model="fecha_fin"
                label="Fecha final"
                :min="fecha_ini"
                :max="fecha_hoy"
              >
                <template #message-danger v-if="errorFields.includes('fecha_fin')">
                    Requerido
                </template>
              </vs-input>
              <div v-if="fecha_fin !== ''" @click="fecha_fin = '', fecha_ini = ''" class="tache">
                  <i class="far fa-times-circle"></i>
              </div>
            </vs-col>
            <vs-col w="4">
               <vs-input
                v-model="asunto"
                label="Contenido específico"
                placeholder="Asunto, cuerpo del correo"
              />
              <div v-if="asunto !== ''" @click="asunto = ''" class="tache">
                  <i class="far fa-times-circle"></i>
              </div>
            </vs-col>
            <vs-col w="4">
              <vs-input
                v-model="correo"
                label="Correo"
              >
                <template v-if="validEmail" #message-success>
                  Correo valido
                </template>
                <template v-if="!validEmail && correo !== ''" #message-danger>
                  Correo invalido
                </template>
              </vs-input>
              <div v-if="correo !== ''" @click="correo = ''" class="tache">
                  <i class="far fa-times-circle"></i>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <enviados v-if="activeEnviados == true" @reAbrirEnviados="getAbrirEnviados()" :enviadosInfo="enviadosInfo" :enviados="emails" :institucion="institucion" :cicloEscolar="cicloEscolar" :pages="pages" :page="page" @refreshTablePage="getInformacion" @refreshTable="getRefreshTable()"></enviados>
      <save v-if="activeGuardados === true" @reAbrirGuardados="getAbrirGuardados()" :guardadosInfo="guardadosInfo" :guardados="emails"  :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getRefreshTable()" :key="compChild" :pages="pages" :page="page" @refreshTablePage="getRefreshTable"></save>
      <salida v-if="activeSalida === true" @reAbrirSalida="getAbrirSalida()" :activeSalida="activeSalida" :salidaInfo="salidaInfo" :enviados="enviados" @refreshTable="getRefreshTable()"></salida>
      <redactar v-if="salida === true" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getRefreshTable()"></redactar>
    </vs-col>
    </vs-row>
  </div>
</template>

<script>
import enviados from './enviados.vue'
import save from './guardados.vue'
import redactar from './redactar.vue'
import salida from './salida.vue'
import mailing from '../../../api/requests/mailing.js'
export default {
    data(){
        return{
          active: '',
          activeEnviados: true,
          enviadosInfo: false,
          activeGuardados: false,
          guardadosInfo: false,
          activeSalida: false,
          salidaInfo: false,
          emails: [],
          salida: false,
          institucion: '',
          instituciones: [],
          institucionId: (new Date()).getTime(),
          errorInstituto: false,
          cicloId: (new Date()).getTime(),
          ciclosEscolares: [],
          cicloEscolar: '',
          errorCiclo:false,
          show: true,
          sumaTotalGuardados: 0,
          totalProceso: 0,
          totalEnviados: 0,
          compChild: 0,
          page: 1, 
          max: 20,
          pages: 0,
          filter:'',
          tipoCorreo: true,

          activeFiltros: false,
          loadingGeneral: null,
          errorFields:[],
          fecha_ini:'',
          fecha_fin: '',
          asunto: '',
          correo: '',
          origen: ''
        }
    },
    components: {
      enviados,
      save,
      salida,
      redactar
    },
    computed: {
      validEmail() {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.correo)
      },
    },
    created(){
        this.getInstituciones()
        const fecha_actual = new Date();
        const day = fecha_actual.getDate() + 1;
        const mounth = (fecha_actual.getMonth() + 1) < 10 ? '0' + (fecha_actual.getMonth() + 1) : fecha_actual.getMonth() + 1
        const year = fecha_actual.getFullYear()
        this.fecha_hoy = year + '-' + mounth + '-' + day
    },
    methods: {
      getRefreshTable(page){
        this.getEnviadosRefres(page)
        this.compChild += 1;
      },
      changePestana(){
        this.salida = true
        this.active = ''
        this.activeEnviados = false
        this.enviadosInfo = false
        this.activeGuardados = false
        this.guardadosInfo = false
        this.activeSalida = false
        this.salidaInfo = false
      },
      async getInstituciones(){
        try {
            const response = await mailing.getInstitucion()
            this.instituciones = response.data
        }
        catch{
            
        }
      },
      async getCicloEscolar() {
        this.ciclosEscolares = []
        this.cicloEscolar = ''
          const { data: response } = await mailing.getCiclosEscolares(this.institucion)
          this.ciclosEscolares = response
          this.cicloId = (new Date()).getTime()
      },
      getInformacion(page){
        this.getEnviados(page)
      },
      getOpcion(valor){
        if(valor === 'enviados'){
          this.tipoCorreo = true
          this.activeEnviados = true
          this.enviadosInfo = !this.enviadosInfo
          this.activeGuardados = false
          this.guardadosInfo = false
          this.activeSalida = false
          this.salidaInfo = false
          this.salida = false
          this.getEnviados()
        }
        if(valor === 'guardados'){
          this.tipoCorreo = false
          this.activeEnviados = false
          this.enviadosInfo = false
          this.activeGuardados = true
          this.guardadosInfo = !this.guardadosInfo
          this.activeSalida = false
          this.salidaInfo = false
          this.salida = false
          this.getEnviados()
        }
        if(valor === 'salida'){
          this.activeEnviados = false
          this.enviadosInfo = false
          this.activeGuardados = false
          this.guardadosInfo = false
          this.activeSalida = true
          this.salidaInfo = !this.salidaInfo
          this.salida = false
        }
      },
      getAbrirEnviados(){
          this.activeEnviados = true
          this.enviadosInfo = false
      },
      getAbrirGuardados(){
          this.activeGuardados = true
          this.guardadosInfo = false
      },
      getAbrirSalida(){
          this.activeSalida = true
          this.salidaInfo = false
      },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion){
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
      async getEnviados(page){
        let params = {
            "page": page ? page : 1,
            "institucion_id": this.institucion,
            "ciclo_escolar_id": this.cicloEscolar,
            "sended": this.tipoCorreo
        }
        if(this.fecha_ini){
          params.fecha_ini = this.fecha_ini
          if (!this.fecha_fin){
              this.errorFields.push('fecha_fin')
          }
          if (!this.errorFields.length){
              params.fecha_fin = this.fecha_fin
          }
        }
        if(this.asunto){
          params.subject_body = this.asunto
        }
        if(this.correo){
          params.email = this.correo
        }
        if(this.origen){
          params.origen = this.origen
        }
        if(this.sanityForm() && !this.errorFields.length){
          const loading = this.$vs.loading()
          try {
              const { data: response } = await mailing.getEnviados(params)
              const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
              loading.close()
              this.emails = dataTable
              this.pages = Math.ceil(total/per_page) || 0
            // this.totalProceso = this.totalUsariosProceso(response)
            // this.totalEnviados = this.totalUsariosEnviados(response.mails)
          }catch(error){
            console.error(error)
              loading.close()
              this.$vs.notification({
                  title: 'Algo salio mal.',
                  text: 'Por favor contacte al administrador. enviado'
              })
          }
        }
        
      },
      async getEnviadosRefres(page){
          if(this.cicloEscolar !== ''){
              const loading = this.$vs.loading()
              try {
                  let params = {
                      "page": page ? page : 1,
                      "institucion_id": this.institucion,
                      "ciclo_escolar_id": this.cicloEscolar,
                      "sended": this.tipoCorreo
                  }
                  if(this.fecha_ini){
                    params.fecha_ini = this.fecha_ini
                    if (!this.fecha_fin){
                        this.errorFields.push('fecha_fin')
                    }
                    if (!this.errorFields.length){
                        params.fecha_fin = this.fecha_fin
                    }
                  }
                  if(this.asunto){
                    params.subject_body = this.asunto
                  }
                  if(this.correo){
                    params.email = this.correo
                  }
                  if(this.origen){
                    params.origen = this.origen
                  }
                  const { data: response } = await mailing.getEnviados(params)
                  loading.close()
                  const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                  loading.close()
                  this.emails = dataTable
                  this.pages = Math.ceil(total/per_page) || 0
              }
              catch(error){
                console.error(error)
                  loading.close()
                  this.$vs.notification({
                      title: 'Algo salio mal.',
                      text: 'Por favor contacte al administrador. enviado'
                  })
              }
          }  
      },
      totalUsarios(info){
        let suma = 0
        info.forEach(i => {
          if(i.sended === 0){
            suma = suma + 1
          }
        })
        this.sumaTotalGuardados = suma
      },
      totalUsariosEnviados(info){
        let suma = 0
        info.forEach(i => {
          if(i.sended === 1){
            suma = suma + 1
          }
        })
        return suma

      },
      totalUsariosProceso(info){
          let suma = 0
          info.forEach(i => {
            if(i.mail.sended === 1){
              suma = suma + 1
            }
          })
          return suma

        }
    },
    watch:{
      active(){
        if(this.active !== ''){
          this.salida = false
        }
        if(this.active === 'enviados'){
        }
      },
      institucion(){
        this.getCicloEscolar()
      }
    }
}
</script>

<style scoped>
.card{
  width: 95%;
  margin: 16px auto 0 auto;
  /* position: relative; */
  min-height: 150px;
  padding: 1%;
  display: flex;
  justify-content: center;
}

.card .vs-sidebar-content{
  border-radius: 0;
}

.hijo{
  display: inline-block;
}


</style>
<style>
.menu .vs-sidebar__item .vs-sidebar__item__text{
  width: 100% !important;
}
.vs-sidebar-content.relative{
  z-index: 1;
}

.vs-select__label{
  z-index: 1 !important;
}

.cBlue{
  color:#195BFF
}
.cGray{
  color:gray
}

.anchoLetra{
  font-weight: 900; 
  font-size: 0.9rem
}

.anchoIcono{
  font-weight: 900; 
  font-size: 1.2rem
}

.trapezium {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 6px solid #195BFF;
    transform: rotate(90deg);
}

.botonEstilos{
  width: 100%;
  text-align: left;
  border: none;
  background: none;
  padding: 0;
}
</style>

<style lang="scss" scoped>
  .tache{
      position: absolute;
      cursor: pointer;
      top: 20px;
      @media only screen and (max-width: 768px) {
          left: calc(95% - 4em);
      }
      @media only screen and (min-width: 768px) {
          left: calc(98% - 4em);
      }
  }
</style>
